(function(){
  'use strict';

  var extras = [
    {label:'Bombas', handle:'bomba-de-vacio', icon:'la-circle', bg:'#f4dfd2'},
    {label:'Accesorios', handle:'accesorios', icon:'la-star', bg:'#e5ebf7'},
    {label:'Aceites y afrodisíacos', handle:'aceites-y-afrodisiacos', icon:'la-tint', bg:'#f7e7c9'},
    {label:'Anillos', handle:'anillos', icon:'la-circle', bg:'#e3dcf6'},
    {label:'Disfraces', handle:'disfraces', icon:'la-heart', bg:'#f5dce8'},
    {label:'Juegos', handle:'juegos-de-mesa', icon:'la-star', bg:'#dcefdc'}
  ];

  function isMobile(){
    return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
  }

  function normalizeLinks(root){
    if (!isMobile()) return;
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('.ehf-more, .erectus-mobile-category-more'), function(link){
      link.setAttribute('href', '#categorias');
      link.setAttribute('role', 'button');
      if (!link.hasAttribute('data-erectus-expanded')) link.setAttribute('data-erectus-expanded', 'false');
      link.setAttribute('aria-expanded', link.getAttribute('data-erectus-expanded') === 'true' ? 'true' : 'false');
    });
  }

  function currentHandle(){
    var match = (window.location.pathname || '').match(/^\/collections\/([^\/?#]+)/);
    return match && match[1] ? decodeURIComponent(match[1]).toLowerCase() : '';
  }

  function addHomeExtras(grid){
    extras.forEach(function(category){
      var link = document.createElement('a');
      link.className = 'ehf-item';
      link.href = '/collections/' + category.handle;
      link.setAttribute('data-erectus-extra-category', 'true');
      link.setAttribute('aria-label', category.label);

      var icon = document.createElement('span');
      icon.className = 'ehf-icon';
      icon.style.backgroundColor = category.bg;
      icon.innerHTML = '<i class="las ' + category.icon + '" aria-hidden="true"></i>';

      var label = document.createElement('span');
      label.className = 'ehf-label';
      label.textContent = category.label;

      link.appendChild(icon);
      link.appendChild(label);
      grid.appendChild(link);
    });
  }

  function addCollectionExtras(grid){
    var current = currentHandle();
    extras.forEach(function(category){
      var link = document.createElement('a');
      link.className = 'erectus-mobile-category-link';
      link.href = '/collections/' + category.handle;
      link.textContent = category.label;
      link.setAttribute('data-erectus-extra-category', 'true');
      if (current === category.handle) {
        link.classList.add('is-active');
        link.setAttribute('aria-current', 'page');
      }
      grid.appendChild(link);
    });
  }

  function removeExtras(container){
    Array.prototype.forEach.call(container.querySelectorAll('[data-erectus-extra-category="true"]'), function(node){
      if (node.parentNode) node.parentNode.removeChild(node);
    });
  }

  function toggle(link){
    var home = link.classList.contains('ehf-more');
    var grid = home
      ? document.querySelector('#erectus-home-families .ehf-grid')
      : document.querySelector('#erectus-mobile-category-nav .erectus-mobile-category-grid');
    if (!grid) return;

    var expanded = link.getAttribute('data-erectus-expanded') === 'true';
    if (expanded) {
      removeExtras(grid);
      link.setAttribute('data-erectus-expanded', 'false');
      link.setAttribute('aria-expanded', 'false');
      link.textContent = home ? 'Ver todas las categorías' : 'Ver más categorías';
      return;
    }

    removeExtras(grid);
    if (home) addHomeExtras(grid);
    else addCollectionExtras(grid);
    link.setAttribute('data-erectus-expanded', 'true');
    link.setAttribute('aria-expanded', 'true');
    link.textContent = 'Ver menos categorías';
  }

  document.addEventListener('click', function(event){
    if (!isMobile()) return;
    var target = event.target;
    var link = target && target.closest ? target.closest('.ehf-more, .erectus-mobile-category-more') : null;
    if (!link) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    toggle(link);
  }, true);

  var timer = null;
  function queueNormalize(){
    window.clearTimeout(timer);
    timer = window.setTimeout(function(){ normalizeLinks(document); }, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ normalizeLinks(document); });
  } else {
    normalizeLinks(document);
  }

  document.addEventListener('shopify:section:load', function(event){ normalizeLinks(event.target || document); });
  document.addEventListener('collection:updated', queueNormalize);

  if (window.MutationObserver) {
    new MutationObserver(queueNormalize).observe(document.documentElement, {childList:true, subtree:true});
  }
})();
